/* Taslak C: shared selection state and accessible, dependency-free gallery controls.
   Load before hst.js and htk.js. The URL receiver runs synchronously before quiz restore. */
(function () {
  'use strict';
  var HT = function (k, d) { var o = window.HST_I18N; return (o && o[k]) || d; };
  var key = 'hst_onbakim', total = 33, maxLength = 200, memory = null;
  function normalize(list) {
    if (!Array.isArray(list)) return [];
    var clean = [];
    list.slice(0, 100).forEach(function (item) {
      if (typeof item !== 'string' || /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(item)) return;
      item = item.replace(/\s+/g, ' ').trim();
      if (item && item.length <= maxLength && clean.length < total && clean.indexOf(item) < 0) clean.push(item);
    });
    return clean;
  }
  function save(list) {
    memory = { items: normalize(list), total: total };
    try { sessionStorage.setItem(key, JSON.stringify(memory)); } catch (e) { /* Private mode: retain this page's state. */ }
    return memory;
  }
  function read() {
    try {
      var stored = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (stored && Array.isArray(stored.items)) return { items: normalize(stored.items), total: total };
    } catch (e) { /* Invalid saved data is ignored. */ }
    return memory || { items: [], total: total };
  }
  function interactive(el, enabled) {
    if (!el) return;
    el.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    el.toggleAttribute('inert', !enabled);
    /* The tabindex fallback also protects browsers predating native inert support. */
    el.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (target) {
      if (!enabled && !target.hasAttribute('data-hst-tabindex')) {
        target.setAttribute('data-hst-tabindex', target.getAttribute('tabindex') || '');
        target.setAttribute('tabindex', '-1');
      } else if (enabled && target.hasAttribute('data-hst-tabindex')) {
        var previous = target.getAttribute('data-hst-tabindex');
        if (previous === '') target.removeAttribute('tabindex'); else target.setAttribute('tabindex', previous);
        target.removeAttribute('data-hst-tabindex');
      }
    });
  }
  function motion() {
    return 'smooth';
  }
  window.HSTC = { normalize: normalize, read: read, save: save, interactive: interactive, motion: motion };
  try {
    /* URLSearchParams performs the only decoding step. Literal % sequences stay literal. */
    var incoming = new URLSearchParams(window.location.search).get('ob');
    if (incoming !== null && incoming.length <= 8192) {
      var trimmed = incoming.trim(), list;
      if (trimmed.charAt(0) === '[') {
        try { list = JSON.parse(trimmed); } catch (e) { list = null; }
      } else list = trimmed.split(/[;\n|]/);
      if (Array.isArray(list)) {
        var valid = normalize(list);
        if (valid.length || !trimmed) save(valid);
      }
    }
  } catch (e) { /* Unsupported URL APIs must not interrupt booking. */ }

  function offset(track, item) {
    return item.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - track.clientLeft;
  }
  function frame(fn) {
    var pending = false;
    return function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; fn(); });
    };
  }
  function init() {
    document.querySelectorAll('[data-hst-gal]').forEach(function (gallery) {
      if (gallery.__hstC) return;
      gallery.__hstC = true;
      var track = gallery.querySelector('.hst-gal__main');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.hst-gal__slide'));
      var thumbs = gallery.querySelectorAll('.hst-gal__thumb');
      var prev = gallery.querySelector('[data-gal-prev]'), next = gallery.querySelector('[data-gal-next]');
      var status = gallery.querySelector('[data-gal-status]'), active = 0;
      if (!slides.length) return;
      function mark(index) {
        active = Math.max(0, Math.min(index, slides.length - 1));
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-label', HT('img', 'Görsel ') + (i + 1));
          thumb.classList.toggle('is-on', i === active);
          thumb.setAttribute('aria-pressed', i === active ? 'true' : 'false');
          if (i === active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
        });
        slides.forEach(function (slide, i) { interactive(slide, i === active); });
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = active === slides.length - 1;
        if (status) status.textContent = (active + 1) + ' / ' + slides.length;
      }
      function go(index) {
        index = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: offset(track, slides[index]), behavior: motion() });
        mark(index);
      }
      function sync() {
        var closest = 0, distance = Infinity;
        slides.forEach(function (slide, i) {
          var d = Math.abs(offset(track, slide) - track.scrollLeft);
          if (d < distance) { closest = i; distance = d; }
        });
        mark(closest);
      }
      thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { go(i); }); });
      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });
      gallery.addEventListener('keydown', function (event) {
        var destinations = { ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1 };
        if (Object.prototype.hasOwnProperty.call(destinations, event.key)) { event.preventDefault(); go(destinations[event.key]); }
      });
      track.addEventListener('scroll', frame(sync), { passive: true });
      window.addEventListener('resize', frame(sync));
      mark(0);
    });

    document.querySelectorAll('[data-hst-carousel]').forEach(function (carousel) {
      if (carousel.__hstC) return;
      carousel.__hstC = true;
      var track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.hst-c-door'));
      var dots = carousel.querySelectorAll('[data-carousel-dot]');
      var prev = carousel.querySelector('[data-carousel-prev]'), next = carousel.querySelector('[data-carousel-next]');
      var status = carousel.querySelector('[data-carousel-status]'), active = 0, requested = null;
      if (!cards.length) return;
      function visible() {
        var bounds = track.getBoundingClientRect();
        return cards.map(function (card) {
          var rect = card.getBoundingClientRect();
          return Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) >= rect.width * 0.5;
        });
      }
      function mark() {
        var visibility = visible();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-on', i === active);
          dot.classList.toggle('is-visible', !!visibility[i]);
          dot.setAttribute('aria-pressed', i === active ? 'true' : 'false');
          if (i === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        cards.forEach(function (card, i) { card.classList.toggle('is-current', i === active); });
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = active === cards.length - 1;
        if (status) status.textContent = (active + 1) + ' / ' + cards.length;
      }
      function go(index) {
        active = Math.max(0, Math.min(index, cards.length - 1));
        requested = active;
        var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        track.scrollTo({ left: Math.min(maximum, Math.max(0, offset(track, cards[active]))), behavior: motion() });
        mark();
      }
      function sync() {
        var visibility = visible();
        /* Dots 6/7/8 intentionally keep distinct selections at the desktop end clamp. */
        if (requested === null) {
          var first = visibility.indexOf(true);
          if (first >= 0) active = first;
        }
        mark();
      }
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { go(i); }); });
      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });
      track.addEventListener('pointerdown', function () { requested = null; }, { passive: true });
      track.addEventListener('touchstart', function () { requested = null; }, { passive: true });
      track.addEventListener('wheel', function () { requested = null; }, { passive: true });
      track.addEventListener('scroll', frame(sync), { passive: true });
      track.addEventListener('focusin', function (event) {
        var card = event.target.closest('.hst-c-door'), index = cards.indexOf(card);
        if (index >= 0 && index !== active) go(index);
      });
      carousel.addEventListener('keydown', function (event) {
        if (event.target.matches('input, textarea, select')) return;
        var destinations = { ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: cards.length - 1 };
        if (Object.prototype.hasOwnProperty.call(destinations, event.key)) { event.preventDefault(); go(destinations[event.key]); }
      });
      window.addEventListener('resize', frame(function () { go(active); }));
      mark();
    });

    /* No block is present until both approved real case images are supplied. */
    document.querySelectorAll('[data-hst-compare]').forEach(function (box) {
      var range = box.querySelector('[data-compare-range]'), after = box.querySelector('[data-compare-after]');
      if (!range || !after) return;
      function sync() {
        var minimum = Number(range.min) || 0, maximum = Number(range.max) || 100;
        var percent = Math.max(0, Math.min(100, (Number(range.value) - minimum) / (maximum - minimum) * 100));
        box.style.setProperty('--reveal', percent + '%');
        after.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      }
      range.addEventListener('input', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
